export const formatAddress = (address, city, state) => `${address}, ${city}, ${state}`
